import { Builder } from '../components/builder/Builder.tsx';

// Replaces the prior static design preview. The real builder UI lives in
// src/web/components/builder/. This page is a thin wrapper that mounts the
// Builder for a blank team — chat-driven flows that open with an existing
// team will eventually pass it via initialTeam.
export function TeamBuild() {
  return <Builder regulationId="M-A" />;
}
